/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import { getData } from 'conversations-async-data/async-data/operators/getters';
import { useAsyncForm } from 'conversations-thread-data/forms/hooks/useAsyncForm';
import FormContextUpdateMessage from './FormContextUpdateMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormContextUpdateMessageContainer = props => {
  const {
    formId
  } = props;
  const {
    asyncForm
  } = useAsyncForm({
    formId
  });
  return /*#__PURE__*/_jsx(FormContextUpdateMessage, Object.assign({
    form: getData(asyncForm)
  }, props));
};
FormContextUpdateMessageContainer.displayName = 'FormContextUpdateMessageContainer';
export default FormContextUpdateMessageContainer;